export default {"src":"/_next/static/media/cross.ca805855.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};